import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { AiFillCaretRight } from "react-icons/ai";
import { ButtonLoading } from "../../../components/buttons/button-loading";
import { ROUTES } from "../../../helpers/constants";
import { formatCLP } from "../../../helpers/functions";
import CatalogAPI from "../../../services/api/catalog.api";

const Purchase = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const client = state?.client;
  const [catalog, setCatalog] = useState([]);
  const [catalogLoading, setCatalogLoading] = useState(true);

  useEffect(() => {
    if (!client) navigate(ROUTES.CLIENTS.route, { replace: true });
  }, [client, navigate]);

  useEffect(() => {
    setCatalogLoading(true);
    CatalogAPI.getCatalog()
      .then((res) => setCatalog(res?.data ?? []))
      .catch(() => {})
      .finally(() => setCatalogLoading(false));
  }, []);

  if (!client) {
    return null;
  }

  const handleSelectPlan = (plan) => {
    if (!client?.id) return;
    navigate(ROUTES.CHECKOUT.route, { state: { client, plan } });
  };

  return (
    <div className="gm-clients-details-container">
      <Toaster />

      <div className="gm-cd-top-navigation">
        <div className="gm-cd-top-info">
          <button className="gm-cd-back" type="button" onClick={() => navigate(-1)}>
            Volver
          </button>
          {client?.name && (
            <>
              <AiFillCaretRight />
              <div className="gm-cd-company-info">{client.name}</div>
            </>
          )}
        </div>
      </div>

      <div className="gm-folder-container">
        <div className="gm-folder-title">Tests Actuales</div>
        <div className="gm-folder-content-container gm-col--2">
          <div className="gm-folder-section">
            <div className="gm-folder-stadistic-section">
              <div className="gm-info-group">
                <div className="gm-folder-label">Tests Enviados</div>
                <div className="gm-number-info">{client?.testsDone || 0}</div>
              </div>
              <div className="gm-info-group">
                <div className="gm-folder-label">Tests Disponibles</div>
                <div className="gm-number-info">{client?.testsAvailable || 0}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gm-folder-container" style={{ marginTop: 20 }}>
        <div className="gm-folder-title">Elige tu plan</div>
        <div className="gm-folder-content-container">
          <div className="gm-plan-cards-container">
            {catalog.map((plan) => (
              <div
                key={plan.id}
                className={`gm-plan-card${plan.isRecommended ? " gm-plan-card--recommended" : ""}`}
              >
                {plan.isRecommended && (
                  <div className="gm-plan-badge">Más Popular</div>
                )}
                <div className="gm-plan-name">{plan.name}</div>
                <div className="gm-plan-tests-label">
                  {plan.testsQuantity} {plan.testsQuantity === 1 ? "test" : "tests"}/año
                </div>
                <div className="gm-plan-price">{formatCLP(plan.totalPrice)}</div>
                <div className="gm-plan-price-period">al año</div>
                <div className="gm-plan-unit-price">
                  {formatCLP(plan.unitPrice)} por test
                </div>
                {plan.discountPercentage > 0 && (
                  <div className="gm-plan-discount">
                    {plan.discountPercentage}% ahorro
                  </div>
                )}
                <ButtonLoading
                  type="button"
                  className={`gm-plan-buy-btn${plan.isRecommended ? " gm-plan-buy-btn--recommended" : ""}`}
                  disabled={catalogLoading}
                  loading={catalogLoading}
                  onClick={() => handleSelectPlan(plan)}
                  buttonLabel={catalogLoading ? "" : "Comprar"}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Purchase;
